window.addEventListener("load", function() {
    //console.log("loaded testimonials");
      // store testimonial nav variable
      var myTestimonialNav = document.querySelectorAll(".testimonial-nav > li > a");
    // console.log(myTestimonialNav);
    function myTestimonialClicks(testimonialClickEvent) {
    //   console.log("click");
      // clear current active on nav
      for (var i = 0; i < myTestimonialNav.length; i++) {
              myTestimonialNav[i].classList.remove("active");
      }
      
      //grab clickedTarget and active on nav
          var clickedTestimonial = testimonialClickEvent.currentTarget;
          clickedTestimonial.classList.add("active");
      testimonialClickEvent.preventDefault();
      
      // store testimonial panes variable
      var myImagePanes = document.querySelectorAll(".testimonial-image-wrapper > .testimonial-image");
    //   console.log(myImagePanes);
      //clear current active on panes
          for (i = 0; i < myImagePanes.length; i++) {
              myImagePanes[i].classList.remove("active");
      }
  
      // store testimonial panes variable
      var myContentPanes = document.querySelectorAll(".testimonial-wrapper > .testimonial");
    //   console.log(myContentPanes);
      //clear current active on panes
          for (i = 0; i < myContentPanes.length; i++) {
              myContentPanes[i].classList.remove("active");
      }
  
      
      // get target pane from nav href
      var anchorReference = testimonialClickEvent.target;
      
      var activePaneId = anchorReference.getAttribute("href");
  
      var activeImageId = activePaneId + '-image';
      
      var activePane = document.querySelector(activePaneId);
  
      var activeImage = document.querySelector(activeImageId);
      
      //add active to pane
      activePane.classList.add("active");
      activeImage.classList.add("active");
    }
    
    for (i = 0; i < myTestimonialNav.length; i++) {
        myTestimonialNav[i].addEventListener("click", myTestimonialClicks)
    }
});